import React from 'react';
import AttributeSelect from './AttributeSelect';

interface Props {
  value: string | '';
  onChange: (id: string | '') => void;
  label?: string;
  className?: string;
}

const LocationSelect: React.FC<Props> = ({ value, onChange, label = 'Location', className }) => (
  <AttributeSelect kind="locations" label={label} value={value} onChange={onChange} className={className} />
);

export default LocationSelect;
